import colorShades from "./utils/colorShades";
import Theme from "./generated/theme.json";
import { PRIMARY_SHADES } from "./Constants";
const PRIMARY_COLOR = "info";
const DEFAULT_RADIUS = 0;
const Sawmill = ({
  colorScheme,
  customColors
}) => ({
  defaultRadius: DEFAULT_RADIUS,
  breakpoints: Theme.breakpoints,
  colors: colorShades(colorScheme, customColors == null ? void 0 : customColors.variant),
  colorScheme,
  fontFamily: Theme.fontFamily,
  fontFamilyMonospace: Theme.fontFamilyMonospace,
  fontSizes: Theme.fontSizes,
  headings: Theme.headings,
  other: {
    customColors
  },
  primaryColor: PRIMARY_COLOR,
  primaryShade: PRIMARY_SHADES,
  spacing: Theme.spacing
});
export default Sawmill;
